import React, { useState } from "react";

const GenderOptions = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <div className="flex flex-col items-center justify-center gap-8 my-8 px-4 md:flex-row md:my-12 md:px-6">
        <div className="flex flex-col items-center justify-center gap-6 w-full md:w-1/2">
          <div
            className="relative group w-full h-64 sm:h-80 rounded-xl overflow-hidden shadow-lg transition-shadow duration-500 hover:shadow-2xl cursor-pointer"
            onClick={() => setShowModal(true)}
          >
            <img
              src="https://flitzstorebrapi.duckdns.org/uploads/customize/1746220044075_file_00000000f8506230a06368a4b09bbb93%20(1).png"
              alt="Banner Flitz"
              className="w-full h-full object-cover transition-transform duration-500 transform group-hover:scale-105"
            />
            <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-50 text-center opacity-0 group-hover:opacity-100 transition-opacity duration-500">
              <h2 className="text-white font-extrabold text-2xl sm:text-4xl drop-shadow-md">FLITZ MASCULINO</h2>
              <p className="text-white text-sm sm:text-lg mt-2">
                Estilo e desempenho para o dia a dia e treinos intensos
              </p>
            </div>
            <div className="absolute bottom-0 left-0 right-0 p-4 bg-gradient-to-t from-black via-transparent to-transparent">
              <p className="text-white text-xs sm:text-sm opacity-80">
                Conheça nossa seleção com design robusto e esportivo.
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Modal de visualização estilo Story */}
      {showModal && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-90 flex items-center justify-center"
          onClick={() => setShowModal(false)}
        >
          <img
            src="https://flitzstorebrapi.duckdns.org/uploads/customize/1746220044075_file_00000000f8506230a06368a4b09bbb93%20(1).png"
            alt="Flitz Story"
            className="max-h-screen max-w-screen"
          />
        </div>
      )}
    </>
  );
};

export default GenderOptions;